'use client'

import React from 'react'

import TipsImage from '@images/brands/cheongdam/tips.png'
import { Box, HStack, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'
import { CheckIcon } from '@icons/check-icon'
import { SubHeadContainer } from '.'

const TipsItem = ({ text, subText }: { text: string; subText?: string }) => {
  return (
    <HStack alignItems={'flex-start'} gap={3}>
      <VStack>
        <CheckIcon width={25} height={25} />
      </VStack>
      <VStack>
        <Text textStyle={'tipsText'}>{text}</Text>
        {subText ? (
          <Text
            textStyle={'tipsText'}
            display={subText ? 'block' : 'none'}
            color={'#D54300'}
          >
            {subText}
          </Text>
        ) : null}
      </VStack>
    </HStack>
  )
}

const Tips = () => {
  return (
    <SubHeadContainer data-aos="fade-up">
      <VStack>
        <Box position="relative">
          <Image src={TipsImage} width={550} height={180} alt="border-black" />
          <Text
            textStyle={'tipsTitle'}
            color={'black'}
            position={'absolute'}
            textAlign={'center'}
            top={{
              sm: '31%',
              base: '26%'
            }}
            left={'50%'}
            transform="translateX(-35%)"
          >
            TIPS!
          </Text>
        </Box>
        <VStack alignItems={'start'} gap={10} mt={10}>
          <TipsItem
            text={
              'For new short grey hair on the root, such as side burns, spread it while your hair is dry and leave it for some time for better dyeing effect.'
            }
            subText={
              '(However, when you spread them on dry hair, the colour may get on your skin; recommended to use a glove)'
            }
          />
          <TipsItem
            text={
              '3~4 times is recommended for covering grey hair with soft brown, and 5 for dark brown.'
            }
          />
          <TipsItem
            text={
              'The effect may vary by the individual’s hair condition. For thick hair, hair with many new grey hairs, or generally grey hair, you can increase the use time by 1~2 minutes.'
            }
          />
          <TipsItem
            text={
              'It is recommended to stop using the produce once the grey hair is covered and resume when it grows back.'
            }
          />
        </VStack>
      </VStack>
    </SubHeadContainer>
  )
}

export default Tips
